import Button from "@/components/bricks/button/Button";
import { useState } from "react";
import CloseSmallIcon from "../icons/CloseSmallIcon";
import MinusIcon from "../icons/MinusIcon";
import PlusIcon from "../icons/PlusIcon";

export default function AppliedFilterItem(props: {
  labelPrefix?: string;
  label: string;
  removeFilterHandler: () => void;
  eqNeq?: boolean;
  operandHandler?: (eqNeq: boolean) => void;
}) {
  // state
  const [eqNeq, setEqNeq] = useState(props.eqNeq ?? true);

  return (
    <div className="c-applied-filter-item">
      {props.operandHandler && (
        <Button
          icon
          transparent
          color="primary"
          aria-label="Flip filter"
          onClick={() => {
            setEqNeq((prevState) => !prevState);
            if (props.operandHandler) {
              props.operandHandler(eqNeq);
            }
          }}
        >
          {eqNeq ? <PlusIcon height={16} /> : <MinusIcon height={16} />}
        </Button>
      )}

      <span className="c-applied-filter-item-label">
        {props.labelPrefix ? (
          <>
            <span className="c-applied-filter-item-label__prefix">
              {props.labelPrefix}
            </span>{" "}
          </>
        ) : null}
        {props.label}
      </span>
      <Button
        icon
        transparent
        color="primary"
        className="btn--sm"
        aria-label="Fjern filter"
        onClick={props.removeFilterHandler}
      >
        <CloseSmallIcon />
      </Button>
    </div>
  );
}
